<div class="container-fluid psp-container">
  <div class="card mb-4">
    <div class="row align-items-center pt-3">
      <div class="col-lg-6 col-7">
        <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-3">
          <ol class="breadcrumb breadcrumb-links breadcrumb-dark">
            <li class="breadcrumb-item text-primary psp-breadcrumb">
              <a class="text-primary" [routerLink]="'/psp/daily-tasks'">
                Daily Tasks
              </a>
            </li>
            <li aria-current="page" class="breadcrumb-item active text-gray psp-breadcrumb">
              View Roche Patient
            </li>
            <li aria-current="page" class="breadcrumb-item psp-breadcrumb text-muted">
              {{ subscriptionDate }}
            </li>
          </ol>
        </nav>
      </div>
    </div>

    <div class="title d-flex p-3 justify-content-between align-items-center">
      <h2>Add New Patient - ID: {{ pspCode }}</h2>
      <div class="pointer" data-bs-toggle="modal" (click)="openFetchModal()" data-bs-target="#fetch-user-data">
        <span>
          <i class="fa fa-search"></i>
        </span>
        <span class="ftch-text"> Lookup User Data </span>
      </div>
    </div>
    <app-fetch-user-data-modal (fetchData)="receiveUser($event)">
    </app-fetch-user-data-modal>
    <div class="card-body">
      <form #addPatientForm="ngForm" (ngSubmit)="onSubmit(addPatientForm)">
        <h2>Personal details</h2>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="full-name">
                Full Name
              </label>
              <input [(ngModel)]="newPatient.patientFullName" class="input form-control" id="full-name"
                placeholder="Full Name" required ngModel #fullName="ngModel" appCheckValidity pattern="^[A-Za-z -]+$"
                [appCheckValidity]="fullName" type="text" name="patientName"
                [disabled]="isPreFetched && user.fullName.length !== 0" />
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="company"> Company Name</label>
              <ng-select name="companyId" id="company" [(ngModel)]="companyId" [items]="companies" bindLabel="name"
                bindValue="id" [clearable]="false" [disabled]="true">
              </ng-select>
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="phone">
                Mobile Number
              </label>
              <div class="input-group">
                <input [(ngModel)]="newPatient.patientMobileNumber" class="input form-control" id="phone"
                  placeholder="Mobile Number" ngModel #phone="ngModel" appCheckValidity [appCheckValidity]="phone"
                  type="tel" name="phone" pattern="^01[0-9]{9}$" [disabled]="isPreFetched && user.phone.length !== 0"
                  required />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <div class="d-flex justify-content-between">
                <label class="form-control-label" for="nationalId" *ngIf="!passportIdToggleOn; else passportIdBlock">
                  National ID
                </label>
                <ng-template #passportIdBlock>
                  <label class="form-control-label" for="passportId">
                    Passport ID
                  </label>
                </ng-template>
                <label class="custom-toggle custom-toggle-default custom-toggle-95">
                  <input type="checkbox" name="isPassportId" [checked]="passportIdToggleOn"
                    (change)="onNationalIdToggleChange()"
                    [disabled]="isPreFetched && (newPatient.patientPassportId || newPatient.patientNationalId)" />
                  <span class="custom-toggle-slider rounded-circle" data-label-off="Passport Id"
                    data-label-on="National Id">
                  </span>
                </label>
              </div>

              <input *ngIf="!passportIdToggleOn; else passportIdInputBlock" [(ngModel)]="newPatient.patientNationalId"
                class="input form-control" id="nationalId" placeholder="National ID" ngModel #nationalId="ngModel"
                appCheckValidity [appCheckValidity]="nationalId" type="number" name="nationalId" minlength="14"
                maxlength="14" [disabled]="isPreFetched && user.nationalId && user.nationalId.length !== 0"
                [pattern]="nationalIdRegex" required />

              <ng-template #passportIdInputBlock>
                <input [(ngModel)]="newPatient.patientPassportId" class="input form-control" id="passportId"
                  placeholder="Passport ID" ngModel #passportId="ngModel" appCheckValidity
                  [appCheckValidity]="passportId" type="text" name="passportId"
                  [disabled]="isPreFetched && user.passportId && user.passportId.length !== 0" appCheckValidity
                  [appCheckValidity]="passportId" required />
              </ng-template>
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="example-date-input">
                Date Of Birth
              </label>
              <input class="form-control" id="example-date-input" type="date" name="dob"
                [(ngModel)]="patientDateOfBirth" [value]="patientDateOfBirth" ngModel #dob="ngModel" appCheckValidity
                [appCheckValidity]="dob" [disabled]="isPreFetched && user.birthdate !== null" required />
            </div>
          </div>


        </div>
        <hr />
        <h2>Address Details</h2>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="city">
                City
              </label>
              <ng-select [(ngModel)]="newPatient.patientCityId" (change)="onCityChange($event)" id="city" name="city"
                placeholder="Select City" required ngModel #city="ngModel" appCheckValidity [appCheckValidity]="city"
                [clearable]="false" [disabled]="isPreFetched && user.cityId !== null" required>
                <ng-option *ngFor="let city of cities" [value]="city.id">
                  {{ city.name }}
                </ng-option>
              </ng-select>
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="area">
                Area
              </label>
              <ng-select [(ngModel)]="newPatient.patientAreaId" (change)="onAreaChange($event)" id="area" name="area"
                placeholder="Select Area" required ngModel #area="ngModel" appCheckValidity [appCheckValidity]="area"
                [clearable]="false" [disabled]="isPreFetched && user.areaId !== null" required>
                <ng-option *ngFor="let area of areas" [value]="area.id">
                  {{ area.name }}
                </ng-option>
              </ng-select>
            </div>
          </div>
        </div>
        <hr />
        <h2>Program Information</h2>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group mb-0">
              <label class="form-control-label" for="program"> Doctor subscribed program </label>
              <ng-select [(ngModel)]="newPatient.programId" (change)="loadRochePrograms()" id="program" name="program"
                placeholder="Select Program" required ngModel #program="ngModel" appCheckValidity
                [appCheckValidity]="program" [clearable]="false" (change)="onProgramChange()" class="pill-dropdown">
                <ng-option *ngFor="let program of programList" [value]="program.id" class="custom-program-dropdown">
                  {{ program.name }}
                </ng-option>
              </ng-select>

            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12" col-12>
            <div class="form-group mb-0">
              <medication-dosage-form [formControl]="programMedicationsControl" [requireAtLeastOne]="true"
                [isConcomitantTreatment]="false" [simplifiedMode]="true"
                [removeButtonLabel]="'Remove Program'"></medication-dosage-form>
            </div>
          </div>
        </div>

        <hr />
        <h2>Subscription Details</h2>
        <div class="row" [style]="'padding-bottom: 30px;'">

          <div class="col-md-4">
            <app-upload-file [acceptedFileTypes]="uploadFileTypes" [labelName]="'Upload Document'"
              (selectedFile)="onFileUploaded($event)"></app-upload-file>
            <p style="font-size: 12px;">Max number of uploading documents is 10 with size 10 MBs and the allowed
              extensions are images and PDFs </p>
          </div>

          <div class="col-md-3">
            <button class="btn btn-primary ml-3" style="margin-top: 30px;" placeholder="Clear"
              (click)="clearDocuments()" [disabled]="uploadedDocuments?.length==0">
              Clear
            </button>
          </div>

          <div class="col-md-4" *ngIf="uploadedDocuments?.length>0">
            <p style="font-size: 15px;">Selected Documents:</p>
            <div *ngFor="let doc of uploadedDocuments">
              <span style="font-size: 12px;">{{ doc.name }}</span>
            </div>
          </div>
        </div>
        <hr>
        <h2>View Rx</h2>

        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <div class="prescription-cards">
                <div class="prescription-card" [class.disabled]="!rocheTask?.doctor?.rxUrl">
                  <div class="card-content">
                    <div class="icon-container">
                      <svg width="38" height="42" viewBox="0 0 38 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M7.44254 0.912695C7.36987 1.03383 7.34573 1.79264 7.34573 3.89941V6.72473H5.56982H3.78577L3.59208 6.92649L3.39032 7.12018V12.0846V17.0409L2.72843 17.0651C2.17951 17.0893 1.96959 17.1378 1.59024 17.3396C0.984832 17.6382 0.387496 18.2921 0.169496 18.8733C0 19.3172 0 19.406 0 29.5285V39.7317L0.177613 40.1999C0.411655 40.8457 1.15431 41.5883 1.80012 41.8224L2.26828 42H19.8817H37.4952L37.9472 41.8143C38.5445 41.5641 38.9159 41.2735 39.263 40.765C39.828 39.9416 39.7957 40.7085 39.7957 27.2925C39.7957 18.6634 39.7715 15.0874 39.7069 14.7807C39.5778 14.1914 39.3598 13.7878 38.9239 13.3519C38.5123 12.9402 37.9068 12.6173 37.4387 12.5528L37.1319 12.5124V9.81627V7.12018L36.9301 6.92649L36.7364 6.72473H34.9524H33.1766V3.87516C33.1685 1.63916 33.1523 1.00146 33.0636 0.888496C32.9667 0.759445 32.2563 0.751328 20.253 0.751328C7.66055 0.751328 7.54754 0.751328 7.44254 0.912695ZM31.885 7.20904V12.4559H30.5531H29.2212V9.75977V7.05565L29.0113 6.89424C28.7934 6.72473 28.7934 6.72473 18.7193 6.72473H8.63715V4.34336V1.96211H20.2611H31.885V7.20904ZM27.9297 10.2361V12.4559H24.8865C23.1752 12.4559 21.6092 12.4963 21.3186 12.5366C20.3661 12.6981 19.5508 13.2793 19.1472 14.1026C19.0422 14.3044 18.9131 14.7968 18.8485 15.1924C18.792 15.5879 18.687 16.0157 18.6144 16.1449C18.4126 16.5404 17.9767 16.8714 17.5166 16.9682C17.2421 17.0247 15.4905 17.057 12.2939 17.057H7.47481L7.28919 17.2346C6.93398 17.5656 7.11155 18.1871 7.60398 18.3082C7.70898 18.3324 10.0579 18.3486 12.8347 18.3324L17.8798 18.3082L18.4045 18.058C19.3974 17.5898 19.9705 16.7826 20.1077 15.6606C20.1481 15.3377 20.2208 14.9663 20.2611 14.8291C20.3741 14.482 20.8746 14.0058 21.2217 13.9008C21.4154 13.8524 23.3931 13.8282 27.0498 13.8443L32.5792 13.8685L32.8698 14.0623C33.2492 14.3206 33.4752 14.6758 33.5802 15.1601C33.7174 15.8059 33.6528 39.3765 33.5156 39.6994C33.3703 40.0304 33.0393 40.3694 32.6761 40.5551C32.3855 40.7004 31.9819 40.7085 17.4601 40.7085C3.13195 40.7085 2.52657 40.7004 2.21983 40.5551C1.83236 40.3775 1.58207 40.1192 1.41256 39.7237C1.30756 39.4573 1.29145 38.2787 1.29145 29.5285C1.29145 18.7926 1.26731 19.3253 1.71936 18.8491C2.10683 18.4293 2.27634 18.3889 3.97154 18.3486C5.43264 18.3082 5.57793 18.2921 5.72322 18.1468C5.97351 17.8885 5.97351 17.4606 5.73134 17.2185C5.61017 17.0974 5.46488 17.057 5.12584 17.057H4.68191V12.5366V8.01623H16.3058H27.9297V10.2361ZM35.8404 14.1349C35.8404 20.1729 35.8404 20.2617 36.0018 20.4312C36.0906 20.5281 36.2521 20.6249 36.357 20.6572C36.583 20.7137 37.0108 20.5119 37.0835 20.3263C37.1077 20.2536 37.1319 18.7603 37.1319 17.0086V13.8201L37.3176 13.8685C37.6889 13.9896 38.0279 14.256 38.2459 14.6192L38.4638 14.9986L38.488 26.9051C38.5042 33.4516 38.488 38.9972 38.4638 39.2232C38.4073 39.7237 38.1248 40.1918 37.7131 40.4663C37.4225 40.66 37.3579 40.6681 35.9453 40.6923L34.4762 40.7165L34.6457 40.3775C34.7345 40.1838 34.8314 39.8932 34.8556 39.7237L34.8959 39.4169H35.7354C36.6072 39.4169 36.9785 39.312 37.0835 39.0537C37.1077 38.981 37.1319 35.1629 37.1319 30.5698V22.2151L36.9301 22.0214C36.6718 21.755 36.3005 21.755 36.0422 22.0214L35.8404 22.2151V30.1743V38.1254H35.3964H34.9524L34.9363 26.4369C34.9121 15.5072 34.904 14.7323 34.7668 14.3932C34.5488 13.8362 34.0645 13.247 33.6044 12.9806L33.1846 12.7384L33.1766 10.3733V8.01623H34.5085H35.8404V14.1349Z"
                          fill="black" />
                      </svg>
                    </div>
                    <div class="text-content">
                      <h3>View Prescription</h3>
                      <p>Click to view prescription details</p>
                    </div>
                    <div class="action-buttons">
                      <button class="btn-view" (click)="viewAttachedRx(rocheTask, $event)"
                        [disabled]="!rocheTask?.doctor?.rxUrl">
                        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="13" cy="13" r="13" fill="white" />
                          <path
                            d="M12.3083 6.75452C9.73995 6.95102 6.95444 8.62647 4.5964 11.3982C4.06895 12.0187 4 12.129 4 12.3738C4 12.6186 4.06895 12.7289 4.5964 13.3494C6.54075 15.6351 8.8712 17.2416 11.0224 17.7828C11.6429 17.9379 12.1704 18 12.8254 18C13.4942 18 14.0251 17.9345 14.6698 17.769C16.8106 17.2209 19.1204 15.6213 21.0544 13.3494C21.5818 12.7289 21.6508 12.6186 21.6508 12.3738C21.6508 12.129 21.5818 12.0187 21.0544 11.3982C19.11 9.11255 16.7796 7.50605 14.6284 6.96481C13.8872 6.77865 13.0184 6.70281 12.3083 6.75452ZM13.7734 8.01283C15.5764 8.33344 17.4174 9.41248 19.2066 11.1982C19.7926 11.7877 20.2718 12.3152 20.2718 12.3738C20.2718 12.4807 18.8653 13.9286 18.2896 14.4112C16.7589 15.6971 15.2627 16.4659 13.7562 16.7417C13.3528 16.8141 12.3807 16.821 11.9808 16.7555C10.3157 16.4831 8.6023 15.5523 6.92341 14.0148C6.32701 13.4701 5.37897 12.46 5.37897 12.3738C5.37897 12.2669 6.78552 10.819 7.36123 10.3364C9.04013 8.92639 10.7018 8.12659 12.3255 7.94732C12.591 7.91974 13.4666 7.95767 13.7734 8.01283Z"
                            fill="#5D4DCC" />
                          <path
                            d="M12.3841 8.89533C11.4153 9.00909 10.4638 9.59515 9.90881 10.4294C8.9849 11.8153 9.16761 13.67 10.3501 14.849C11.7153 16.2176 13.9354 16.2176 15.3006 14.849C16.6692 13.4838 16.6692 11.2637 15.3006 9.89852C14.7386 9.33315 14.0112 8.98496 13.2218 8.89188C12.8736 8.85396 12.7426 8.85396 12.3841 8.89533ZM13.2907 10.1157C13.4252 10.1433 13.6803 10.2398 13.8595 10.326C14.6214 10.7052 15.1351 11.5257 15.1351 12.3738C15.1351 13.2218 14.6214 14.0423 13.8595 14.4215C13.1494 14.7697 12.5013 14.7697 11.7911 14.4215C11.0292 14.0423 10.5156 13.2218 10.5156 12.3738C10.5156 12.0325 10.6017 11.7015 10.7776 11.3395C11.2361 10.4156 12.2806 9.90542 13.2907 10.1157Z"
                            fill="#5D4DCC" />
                        </svg>
                      </button>
                      <button class="btn-view" (click)="downloadAttachedRx(rocheTask, $event)"
                        [disabled]="!rocheTask?.doctor?.rxUrl">
                        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="13" cy="13" r="13" fill="white" />
                          <path
                            d="M12.7196 7.06967C12.6623 7.10469 12.5891 7.17791 12.554 7.23522C12.4904 7.33709 12.4904 7.40395 12.4904 11.1925V15.0447L11.4334 13.9877C10.6534 13.2141 10.3478 12.9276 10.2777 12.9117C10.2268 12.8989 10.1663 12.8862 10.1472 12.8798C10.0581 12.8544 9.82566 12.9371 9.73015 13.0295C9.59643 13.1568 9.54868 13.3064 9.57733 13.4943C9.59643 13.6407 9.62827 13.6726 11.1628 15.2134C12.8533 16.9071 12.8151 16.8721 13.108 16.8276C13.229 16.8084 13.3468 16.697 14.789 15.258C16.2184 13.8317 16.3426 13.7012 16.3681 13.5739C16.4031 13.4115 16.3712 13.2364 16.2885 13.125C16.1611 12.9531 15.8714 12.8798 15.6517 12.9626C15.604 12.9785 15.101 13.4561 14.5375 14.0196L13.5091 15.0447V11.1925C13.5091 7.40395 13.5091 7.33709 13.4455 7.23522C13.35 7.0824 13.2067 7.00599 12.9998 7.00599C12.882 7.00599 12.7896 7.0251 12.7196 7.06967Z"
                            fill="#5D4DCC" />
                          <path
                            d="M6.33662 15.2038C6.17426 15.2611 6.06601 15.3662 6.02463 15.5031C6.00234 15.5795 5.99597 16.022 6.00234 16.7797C6.01507 17.8908 6.01826 17.9513 6.0883 18.1646C6.39393 19.0879 7.08796 19.7342 8.00167 19.9475C8.31367 20.0175 17.6863 20.0175 17.9983 19.9475C18.6319 19.801 19.2017 19.4158 19.5615 18.8937C19.6888 18.7058 19.8608 18.3365 19.9308 18.101C19.9754 17.9386 19.9881 17.7317 19.9977 16.7638C20.004 15.9966 19.9977 15.5795 19.9754 15.4999C19.9085 15.2834 19.6252 15.1274 19.3768 15.1752C19.2272 15.2038 19.0266 15.3853 18.9853 15.5317C18.9662 15.6018 18.9534 16.0666 18.9534 16.6365C18.9534 17.4228 18.9439 17.6648 18.9057 17.8144C18.7465 18.4225 18.2212 18.8714 17.5781 18.9446C17.2247 18.986 8.7753 18.986 8.42191 18.9446C7.77882 18.8714 7.25351 18.4225 7.09433 17.8144C7.05613 17.6648 7.04658 17.4228 7.04658 16.6365C7.04658 16.0889 7.03384 15.5986 7.01474 15.5381C6.97654 15.3949 6.8078 15.2293 6.66136 15.1879C6.52446 15.1465 6.48307 15.1497 6.33662 15.2038Z"
                            fill="#5D4DCC" />
                        </svg>

                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Doctor Information Section -->
        <hr />
        <h2>Physician Details</h2>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="doctor-name">
                Doctor Name
              </label>
              <input [value]="rocheTask?.doctor?.name || ''" class="input form-control" id="doctor-name" type="text"
                name="doctorName" disabled />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="doctor-code">
                Doctor Code
              </label>
              <input [value]="rocheTask?.doctor?.code || ''" class="input form-control" id="doctor-code" type="text"
                name="doctorCode" disabled />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="doctor-type">
                Doctor Type
              </label>
              <input [value]="rocheTask?.doctor?.type || ''" class="input form-control" id="doctor-type" type="text"
                name="doctorType" disabled />
            </div>
          </div>
        </div>
        <!-- Action Buttons -->
        <div class="row psp-action-button-container mt-4">
          <div class="col btns-block">
            <button class="btn bg-gray text-white" type="button" (click)="goBack()">
              Cancel
            </button>
            <button class="btn btn-primary ml-3" type="submit" [disabled]="!addPatientForm.valid"
              (submit)="onSubmit(addPatientForm)">
              Submit
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<ngx-spinner></ngx-spinner>